import { render, staticRenderFns } from "./OrmMessageListView.vue?vue&type=template&id=94c4fbb0"
import script from "./OrmMessageListView.vue?vue&type=script&lang=js"
export * from "./OrmMessageListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94c4fbb0')) {
      api.createRecord('94c4fbb0', component.options)
    } else {
      api.reload('94c4fbb0', component.options)
    }
    module.hot.accept("./OrmMessageListView.vue?vue&type=template&id=94c4fbb0", function () {
      api.rerender('94c4fbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormmessage/OrmMessageListView.vue"
export default component.exports